import React, { Component } from "react";

import $ from "jquery";
import { LoadingProvider, LoadingContext } from "./loadingContext"; // ✅ Context 추가

import Header from "./header/header";
import Left from "./left/left";
import Map from "./map/map";

import DrawShapes from "./modal/drawShapes";
import Memo from "./modal/memo";
import MapInformation from "./modal/mapInformation";
import MapPrint from "./map/sisPrint";
import {SyncLoader} from "react-spinners";

//Modal
import AtpModal from "./modal/realEstate/AtpModal";
import MapInfoModal from "./modal/MapInfoModal";
import CCTV from "./modal/transportation/cctv";
import Ship from "./modal/transportation/ship";
import Flight from "./modal/transportation/flight";
import Train from "./modal/transportation/train";
import Bus from "./modal/transportation/bus";
import Weather from "./modal/weather/weather";
import WeatherDetail from "./modal/weather/weatherDetail";
import WeatherLegend from "./modal/weather/weatherLegend";
import LayerOption from "./modal/layerOption";
import WorkInfoModal from "./modal/WorkInfoModal";

import SisLoader from "store/sis/component/SisLoader";

import "./index.scss";

class index extends Component {
	state = {
		components: "",
		loading: true, // ✅ 로딩 상태 추가
	};

	componentDidMount() {
		const { params } = this.props.match;
		//console.log(this.loading , "상태 로딩 시작");
		// 로딩 시작
		this.setState({ loading: true }, () => {
			// 상태가 변경된 후 실행
			console.log("로딩 시작:", this.state.loading); // true로 변경된 후 확인
		  });
		// ✅ 로딩 시작 후, 데이터 설정 & 로딩 종료
		setTimeout(() => {
			
		}, 2000); // 2초 후 데이터 로드 (예제)
	}

	render() {
		console.log("Loading 상태:", this.state.loading); // 상태가 잘 변경되는지 확인
		return (
			<LoadingProvider> {/* ✅ 로딩 상태를 모든 컴포넌트에 공유 */}
				<div className="wrap">
					

					{/* ✅ 로딩 상태에 따라 SisLoader 표시 */}
					<LoadingContext.Consumer>
						{({ loading }) => (
							<>
							{/* ✅ 로딩 화면 */}
							<div className={`loadingContainer ${loading ? "" : "hidden"}`}>
								<SyncLoader /><br/>
								<p>데이터 로딩 중...</p>
							</div>

							{/* ✅ 기존 UI 요소 (사라지지 않음) */}
							<div>
								<Header className="headerWrap" />
								<Left className="leftWrap" aboutProps={this.props.location.aboutProps}/>
								<Map className="sisMapWrap" />
							</div>

							{/* 모달 컴포넌트들은 항상 렌더링됨 - 내부에서 Redux 상태(isModalOpen 등)를 이용해 표시 여부 제어 */}
							<AtpModal id="apartModal" />
							<MapInfoModal id="mapInfoModal" />
							<DrawShapes id="drawShapes" />
							<Memo id="memo" />
							<MapPrint id="mapPrint" />
							<MapInformation id="mapInformation" />
							<CCTV id="cctvModal" />
							<Ship id="shipModal" />
							<Flight id="flightModal" />
							<Train id="trainModal" />
							<Bus id="busModal" />
							<Weather id="weatherModal" />
							<WeatherDetail id="weatherDetailModal" />
							<WeatherLegend id="weatherLegendModal" />
							<LayerOption id="layerOption" />
							<WorkInfoModal id="workInfoModal" />
							</>
						)}
						</LoadingContext.Consumer>
				</div>
			</LoadingProvider>
		);
	}
}

export default index;
